module.exports = __webpack_public_path__ + "img/举手.31b54450.png";